import { ActionCell } from 'components/hands/jsx/ActionCell';
import Player from 'components/hands/jsx/Player';
import 'components/hands/css/HandTable.css';

const STREETS = ['preflop', 'flop', 'turn', 'river', 'showdown'];

export const HandTable = ({ gameState }) => {
  const positions = Object.keys(gameState.stacks || {});

  const getActions = (position, street) => {
    const actions = gameState.actions?.[street] || [];
    return actions.filter(a => a.position === position);
  };

  return (
    <div>
      {/* Main Table */}
      <div className="main-table-container">
        <table className="main-table">
          <thead>
            <tr className="table-header">
              <th className="table-header-cell">Player</th>
              {STREETS.map((street, index) => (
                <th key={index} className="table-header-cell">
                  {street}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {positions.map(positionName => (
              <tr key={positionName} className="table-row">
                <td className="table-cell">
                  <Player
                    position={positionName}
                    stack={gameState.stacks[positionName]}
                    readOnly={true}
                  />
                </td>
                {STREETS.map((street, streetIndex) => (
                  <td key={streetIndex} className="table-cell">
                    <ActionCell
                      actions={getActions(positionName, street)}
                      isCurrentlyActing={false}
                      actionRequirements={null}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
